import { yupResolver } from "@hookform/resolvers/yup";
import { Box, Flex, Icon, Text } from "@storyofams/react-ui";
import Image from "next/image";
import { usePostHog } from "posthog-js/react";
import { useForm } from "react-hook-form";
import * as Yup from "yup";
import { useShopify } from "~context";
import { Button } from "~components/common/Button";
import { Gift } from "~components/common/Icons";
import { Input } from "~components/common/Input";
import { Modal } from "~components/common/Modal";
import { shopifySdk } from "~lib/shopify/client";

const schema = Yup.object().shape({
  email: Yup.string().email().required(),
  name: Yup.string().required(),
  date: Yup.string(),
});
export const GiftCardModal = ({
  isOpen,
  close,
  variantId,
  quantity,
  openUpsell,
  price,
  code,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    formState: { isSubmitting, errors, isDirty },
  } = useForm<{ email: string; name: string; date: string }>({
    resolver: yupResolver(schema) as any,
  });
  const posthog = usePostHog();
  const { addItemToCart, cart } = useShopify();
  const onSubmit = async ({ name, email, date }) => {
    posthog.capture("Clicked Add to Cart", {
      source: "Product Page",
      product: "giftcard",
      properties: {
        $process_person_profile: false,
      },
    });
    const attributes = date
      ? [
          {
            key: "Recipient name",
            value: name,
          },
          {
            key: "Recipient email",
            value: email,
          },
          {
            key: "__shopify_send_gift_card_to_recipient",
            value: "true",
          },
          {
            key: "Send on",
            value: date,
          },
        ]
      : [
          {
            key: "Recipient name",
            value: name,
          },
          {
            key: "Recipient email",
            value: email,
          },
          {
            key: "__shopify_send_gift_card_to_recipient",
            value: "true",
          },
        ];
    await addItemToCart(
      [
        {
          quantity,
          merchandiseId: variantId,
          attributes,
        },
      ],
      (id) => {
        openUpsell(true);
        reset();
        close();
        if (code)
          shopifySdk.cartDiscountCodesUpdate({
            cartId: cart?.id || id,
            discountCodes: [code],
          });
      }
    );
  };
  return (
    <Modal isOpen={isOpen} close={close}>
      <Box
        p={["20px", "30px"]}
        bg="#F7EFE7"
        position={"relative"}
        borderRadius={"8px"}
        as="form"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Box
          mx="auto"
          top={-8}
          left={0}
          right={0}
          width={100}
          height={100}
          position={"absolute"}
        >
          <Image
            layout="fill"
            src={
              "https://a.storyblok.com/f/125270/419x282/b78c54461e/timer-bubble.png"
            }
          />
          <Icon
            mt={3}
            ml={3.5}
            fontSize={6}
            position={"absolute"}
            icon={Gift}
          ></Icon>
        </Box>
        <Box textAlign={"center"}>
          <Text
            fontFamily={"DINPro"}
            fontWeight={700}
            fontSize={"28px"}
            mb={"20px"}
            mt="30px"
          >
            {"Cadeaubon gegevens invullen"}
          </Text>

          <Input
            width={"100%"}
            mb="15px"
            textAlign={"start"}
            placeholder="Naam"
            required
            label="Naam van de ontvanger:*"
            {...register("name")}
            error={errors?.name?.message}
          />
          <Input
            width={"100%"}
            mb="15px"
            textAlign={"start"}
            placeholder="E-mail"
            required
            label="Email van de ontvanger:*"
            type="email"
            {...register("email")}
            error={errors?.email?.message}
          />
          <Box textAlign={"start"} mb={1}>
            <Text mb={0.5}>Verzenden op:</Text>
            <Text color={"grey600"}>
              Wordt tussen 04:00 en 10:00 verzonden op de dag dat je hier onder
              instelt. Laat het veld leeg om direct te versturen naar de ontvanger.
            </Text>
          </Box>
          <Input
            width={"100%"}
            mb="30px"
            textAlign={"start"}
            type="date"
            {...register("date")}
            min={new Date().toISOString().slice(0, 10)}
            error={errors?.date?.message}
          />
          <Button
            width={"100%"}
            height={"48px"}
            variant="primary"
            disabled={!isDirty}
            type="submit"
            isLoading={isSubmitting}
          >
            {`Bestel nu! -- ${price}`}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};
